import React from "react";
import Select, { components, GroupBase, OptionProps, SingleValueProps } from "react-select";
import { getUserTagsClient } from "../../services/api-clients.service";
import { _copyAndSort } from "../../utilities/array.helpers";
import "./user-tag-filter.styless.scss";
import { LogicalOperator, UserTagResponseModel } from "../../swagger-clients/s365-admin-panel-clients.service";
import { Button } from "react-bootstrap";
import BootstrapTooltip from "../bootstrap-tooltip/bootstrap-tooltip";
import { ReactSelectTagOption } from "../mother-ticket-tag-select/mother-ticket-tag-select";



type UserTagFilterProps = {
    className: string;
    placeholder: string;
    logicalOperator: LogicalOperator;
    icon?: string;
    iconColor?: string;
    values?: string[] | number[] | undefined | null;
    onOperatorChange: (operator: LogicalOperator) => void;
    onChange?: (values: ReactSelectTagOption[]) => void;
}
export type UserTagFilterType = {
    GetOptions: () => void;
}

export const UserTagFilter = React.forwardRef<UserTagFilterType, UserTagFilterProps>((props, ref) => {

    React.useImperativeHandle(ref, () => ({
        GetOptions: () => { GetOptions(); }
    }));
    const [options, setOptions] = React.useState<ReactSelectTagOption[]>([]);
    const [selectedOptions, setSelectedOptions] = React.useState<ReactSelectTagOption[]>();

    React.useEffect(() => {
        // console.log("UserTagFilter", props.value, options);
        if (props.values === undefined || props.values === null) {
            setSelectedOptions(undefined);
            return;
        }
        //@ts-ignore
        const selectedValues = options.filter(x => props.values?.find(y => +x.value! == +y) !== undefined);
        setSelectedOptions(selectedValues);

    }, [props.values, options]);

    React.useEffect(() => {
        GetOptions();
    }, []);

    const GetOptions = async () => {
        try {
            const client = getUserTagsClient();
            const userTagsResp = await client.getUserTags(null,null, undefined, 0, 10000);
            const sortedTags = sortByParentChild(userTagsResp?.items ?? []);
            const mappedOptions = sortedTags?.map(x => ({ value: x.id, label: x.name, isChild: !!x.parentTagId, isDisabled: !x.parentTagId } as ReactSelectTagOption)) ?? [];
            setOptions(mappedOptions);

        } catch (error) {
            console.log("An error occurred while getting user tags.", error);
        }
    }

    function sortByParentChild(array: UserTagResponseModel[]) {      

        const grouped = array.reduce((acc: any, item: UserTagResponseModel) => {
            const parentId = item.parentTagId || 0;
            acc[parentId] = acc[parentId] || [];
            acc[parentId].push(item);
            return acc;
        }, {});

        for (const parentId in grouped) {
            if (grouped.hasOwnProperty(parentId)) {
                grouped[parentId].sort((a: any, b: any) => a.name.localeCompare(b.name));
            }
        }

        const sortedArray: UserTagResponseModel[] = [];

        function addItems(parentId: number) {
            if (!grouped[parentId]) return;
            grouped[parentId].forEach((item: UserTagResponseModel) => {
                sortedArray.push(item);
                addItems(item.id);
            });
        }

        addItems(0);

        return sortedArray;
    }

    const onOperatorChange = () => {
        const operator = props.logicalOperator == LogicalOperator.And ? LogicalOperator.Or : LogicalOperator.And;
        props.onOperatorChange(operator);
    }


    const CustomOption: React.ComponentType<OptionProps<ReactSelectTagOption, true, GroupBase<ReactSelectTagOption>>> = ({ innerProps, isFocused, data, isDisabled }) =>
        !isDisabled ? (
            <div
                {...innerProps}
                style={{
                    padding: '10px',
                    cursor: 'pointer',
                    backgroundColor: isFocused ? '#DEEBFF' : 'white', // Highlight on hover
                }}
            >
                <span style={{ paddingLeft: data.isChild ? "25px" : undefined }}>{data.label}</span>
                {data.icon && <span style={{ marginLeft: '5px' }} className={data.icon}></span>}
            </div>
        ) : (
            <div
                {...innerProps}
                style={{
                    padding: '10px',
                    cursor: 'not-allowed',
                    color: '#a9a9a9',
                    pointerEvents: 'none',
                    fontWeight: "bold"
                }}
            >
                <span style={{ paddingLeft: data.isChild ? "25px" : undefined }}>{data.label}</span>
                {data.icon && <span style={{ marginLeft: '5px' }} className={data.icon}></span>}
            </div>
        );


    const CustomSingleValue = ({
        children,
        ...props
    }: SingleValueProps<ReactSelectTagOption>) => (
        <components.SingleValue {...props}>{props.data.label}</components.SingleValue>);

    return <div style={{ display: "flex" }}>
        {!!props.icon && <span className="user-tag-select-icon" ><i className={`${props.icon}`} style={{ color: props.iconColor }}></i></span>}
        <BootstrapTooltip tooltipText={<span>
            Logical operator used when filtering multiple selected tags AND or OR.
        </span>} placement="top">
            <Button className="user-tag-select-logic-operator-btn" onClick={onOperatorChange}>{props.logicalOperator == LogicalOperator.And ? "AND" : "OR"}</Button>
        </BootstrapTooltip>

        <Select
            styles={{
                container: (provided, props) => { return { ...provided, flex: 1 } },
                control: (provided) => { if (!!props.icon) { return { ...provided, borderBottomLeftRadius: 0, borderTopLeftRadius: 0 } } return provided; }
            }}
            placeholder={props.placeholder}
            className={props.className}
            value={selectedOptions}
            isClearable
            isMulti
            options={options}
            onChange={(data) => {
                console.log("User tag changed", data);
                props.onChange?.(data as any);
            }}
            components={{ Option: CustomOption, SingleValue: CustomSingleValue }}
        />
    </div>
});